// extracted by mini-css-extract-plugin
export default {"toggleArea":"LightDarkMode_toggleArea__X-Maz"};